var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-table-head',[_c('v-col',{staticClass:"border-r py-2",attrs:{"cols":"2"}},[_vm._v(" SKU ")]),_c('v-col',{staticClass:"border-r py-2 text-truncate",attrs:{"cols":"6"}},[_vm._v("Descrição")]),_c('v-col',{staticClass:"py-2",attrs:{"cols":"3"}},[_vm._v("Divisor")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }